<template>
  <div>
    <div class="dojo landscape">
      <Portal></Portal>
      <transition name="fade">
        <div v-if="loaded">
          <DojoCourse></DojoCourse>
          <Chat></Chat>
        </div>
      </transition>
    </div>
    <div class="portrait">
      <NotOriented></NotOriented>
    </div>
  </div>
</template>

<script>
import { delay } from "@/variables.js";
import Portal from "./Portal";
import MainMixin from "@/components/utilities/MainMixin.vue";
import NotOriented from "@/components/mobile/NotOriented";
import Chat from "@/components/utilities/Chat";
import DojoCourse from "@/components/utilities/DojoCourse";
export default {
  name: "Plantroom",
  mixins: [MainMixin],
  title: "Dojo",
  data() {
    return {
      loaded: false,
    };
  },
  components: {
    Portal,
    NotOriented,
    Chat,
    DojoCourse,
  },
  mounted() {
    this.init();
    let newMsg = {
      text:
        "You entered the sacred temple of Kizi 404's hive-mind. In the dojo, active-listening and constructive criticism allowed us to grow, to learn from each other and to be our own senseis. Open your eyes and ears young padawan, and feel free to share..",
      delay: 10000,
    };

    this.$store.commit("setWanerMsg", newMsg);
    delay(3500).then(() => {
      this.loaded = true;
    });
  },
};
</script>

<style lang="scss" scoped>
.dojo {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/dojo.jpg");
  background-size: 100vw 100vh;
}
</style>
